import React from 'react'
import { GridHeader, GridRow } from 'src/components/Reusable/Grid'
import { getControlsListItemConfig } from '../../IndexItem/ControlsListItem.helpers'
import { ControlListItemConfig } from '../../IndexItem/ControlListItem.constants'
import { ControlsGridHeader } from './ControlsIndexGrid.styles'
import {
  ControlIndexGridChecksHeaders,
  ControlsIndexGridAssigneeHeader,
  ControlsIndexGridDepartmentHeader,
  ControlsIndexGridFrameworksHeader,
  ControlsIndexGridIdHeader,
  ControlsIndexGridLinkedEvidenceHeader,
  ControlsIndexGridNameHeader,
  ControlsIndexGridStatusHeader,
} from './ControlsIndexGrid.components'

export const ControlsIndexGridHeader = ({
  config,
  showContentMatchColumn,
}: {
  config?: ControlListItemConfig
  showContentMatchColumn?: boolean
}): JSX.Element => {
  const {
    showDepartmentColumn,
    showModelIdColumn,
    showControlNameColumn,
    showFrameworkColumn,
    showCheckColumns,
    showLinkedEvidenceColumn,
    showStatusColumn,
    showAssigneeColumn,
    showMenuColumn,
  } = getControlsListItemConfig(config)

  return (
    <GridRow>
      {showContentMatchColumn && <GridHeader />}
      {showDepartmentColumn && <ControlsIndexGridDepartmentHeader />}
      {showModelIdColumn && <ControlsIndexGridIdHeader />}
      {showControlNameColumn && <ControlsIndexGridNameHeader />}
      {showFrameworkColumn && <ControlsIndexGridFrameworksHeader />}
      {showCheckColumns && <ControlIndexGridChecksHeaders />}
      {showLinkedEvidenceColumn && <ControlsIndexGridLinkedEvidenceHeader />}
      {showStatusColumn && <ControlsIndexGridStatusHeader />}
      {showAssigneeColumn && <ControlsIndexGridAssigneeHeader />}
      {showMenuColumn && <ControlsGridHeader />}
    </GridRow>
  )
}
